// extracted by mini-css-extract-plugin
export var form = "meal-planer-template-form-module--form--oceAK";